import cn from 'classnames'
import React, { Fragment, useRef, useCallback, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MatrixMessageComposer from 'matrix-react-sdk/lib/components/views/rooms/MessageComposer'
import ToggleKbSearch from 'ducks/ticketing/components/ToggleKbSearch'
import { selectShowKbSearchOnInboxEditor } from 'ducks/currentUser/selectors/preferences/selectShowKbSearchOnInboxEditor'
import { doSetEditorMode } from 'ducks/editor/operations'
import selectCurrentConversationId from 'ducks/searches/selectors/selectCurrentConversationId'
import { selectRoomFromUrlIsExpired } from 'ducks/chat/selectors/rooms'
import TypingStore from 'matrix-react-sdk/lib/stores/TypingStore'

import FacebookLike from './Controls/FacebookLike'

import RoomSearchKb from '../RoomSearchKb'
import AgentViewingCollision from './AgentViewingCollision'
import Hints from './Hints'

import './styles.less'

export default function MessageComposer(props) {
  const {
    room: { roomId },
  } = props
  const messageComposerRef = useRef(null)
  const [isComposerFocused, setComposerFocused] = useState(false)
  const showKbSearchOnInboxEditor = useSelector(selectShowKbSearchOnInboxEditor)
  const isExpired = useSelector(selectRoomFromUrlIsExpired)
  const dispatch = useDispatch()
  const conversationId = useSelector(selectCurrentConversationId)
  const handleOnEditorModeChange = useCallback(
    ({ isNote }) => {
      const mode = isNote ? 'note' : 'reply'
      TypingStore.sharedInstance().setAllowTypingInRoom(roomId, !isNote)
      dispatch(doSetEditorMode(mode))
    },
    [dispatch, roomId]
  )

  const handleComposerFocus = useCallback(
    () => {
      setComposerFocused(true)
    },
    [setComposerFocused]
  )

  const handleComposerBlur = useCallback(
    () => {
      setComposerFocused(false)
    },
    [setComposerFocused]
  )

  const controls = useMemo(
    () => [
      <FacebookLike key="facebookLike" roomId={roomId} />,
      <ToggleKbSearch
        key="toggleKbSearch"
        size={15}
        className={cn('kbSearchButton', 'composer-button')}
        iconOnly
        forceActive={false}
      />,
    ],
    [roomId]
  )

  if (isExpired) return null

  return (
    <Fragment>
      {showKbSearchOnInboxEditor && (
        <RoomSearchKb messageComposerRef={messageComposerRef} />
      )}
      <MatrixMessageComposer
        {...props} // eslint-disable-line react/jsx-props-no-spreading
        showVoiceButtons={false}
        showReplyPreview
        showUploadBar
        ref={messageComposerRef}
        controls={controls}
        onEditorModeChange={handleOnEditorModeChange}
        onFocus={handleComposerFocus}
        onBlur={handleComposerBlur}
        showSendButton={false}
      />
      <div className="mx_MessageComposer_statusArea">
        <AgentViewingCollision conversationId={conversationId} />
        <Hints isComposerFocused={isComposerFocused} />
      </div>
    </Fragment>
  )
}
